import get from 'lodash/get';

const selectCurrentUser = () => state => (
  get(state, 'auth.user', null)
);

export default selectCurrentUser;
